/**
 * Analytics Component
 * 
 * Initializes Google Analytics 4 on app mount.
 * Only initializes if GA4_MEASUREMENT_ID is set.
 */

import { useEffect } from 'react';
import { initAnalytics } from '@/lib/analytics';

const Analytics = () => {
  useEffect(() => {
    // Initialize analytics when component mounts
    initAnalytics();
  }, []);

  // This component doesn't render anything
  return null;
};

export default Analytics;

